<template lang="pug">
article-item-page-template(:title="pageTitle", :loading="loading")
  template(#header)
    .text-h6(v-html="content.title")
  template(#main)
    v-responsive(v-if="!sm", :aspect-ratio="16 / 9")
      iframe.page-video-iframe.rounded(
        :src="`https://www.youtube.com/embed/${getYoutubeCode(content.link)}`",
        width="100%",
        height="100%",
        frameborder="0",
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen
      )
    iframe.page-video-iframe(
      v-else,
      :src="`https://www.youtube.com/embed/${getYoutubeCode(content.link)}`",
      width="560",
      height="315",
      frameborder="0",
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen
    )
    v-card-subtitle.px-0.font-italic Fonte: {{ content.source }}
  template(#bottom)
    facebook-comments.mb-4.mb-md-0(:href="server + $route.path")
  template(#side)
    communications-widget
</template>

<script>
import ArticleItemPageTemplate from "@/components/templates/ArticleItemPage";
import CommunicationsWidget from "@/components/widgets/Communications";
import FacebookComments from "@/components/widgets/FacebookComments";
import { getYoutubeCode } from "@/components/utils";

const _config = {
  title: "VÍDEOS",
  mod: "videos",
};

export default {
  data: () => ({
    loading: false,
    pageTitle: _config.title,
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    content() {
      return this.$rest(_config.mod).item;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getYoutubeCode,
  },
  created() {
    this.loading = true;

    this.$rest(_config.mod)
      .get({ id: this.itemId })
      .then(() => (this.loading = false))
      .catch(() => {
        this.$router.replace("/error404");
      });
  },
  watch: {
    itemId(v) {
      this.$rest(_config.mod).get({ id: v });
    },
  },
  components: {
    ArticleItemPageTemplate,
    CommunicationsWidget,
    FacebookComments,
  },
};
</script>

<style>
@media screen and (max-width: 600px) {
  .page-video-iframe {
    width: 100% !important;
    height: 300px !important;
  }
}
</style>
